/* istanbul ignore file */
import React from "react";
import {
  DefaultHoofdstuk,
  KlantprofielAlgemeenHoofdstuk,
} from "../../../../.generated/rapportage/rapportagetypes";
import Heading from "../../components/Heading";
import { Paragraph } from "../../components/Paragraph";

interface Props {
  klantprofielAlgemeenHoofdstuk?: KlantprofielAlgemeenHoofdstuk;
  uwKlantprofielHoofdstuk: DefaultHoofdstuk;
}

const UwKlantprofielChapter: React.FC<Props> = ({
  uwKlantprofielHoofdstuk,
  klantprofielAlgemeenHoofdstuk,
}) => {
  return (
    /* istanbul ignore next */
    <section className="chapter uw-klantprofiel">
      {uwKlantprofielHoofdstuk?.titel && (
        <Heading text={uwKlantprofielHoofdstuk.titel} />
      )}
      <Paragraph
        paragraaf={klantprofielAlgemeenHoofdstuk?.paragrafen?.p4090101}
      />
    </section>
  );
};

export default UwKlantprofielChapter;
